"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreAccountTypeEnum = void 0;
/**
 * Основные счета.
 */
var BillingCoreAccountTypeEnum;
(function (BillingCoreAccountTypeEnum) {
  // #region [ Банковские (реальные) счета ]
  /**
   * 51: Счёт в банке или иной финансовой организации.
   * Счета данного типа всегда должны иметь external
   * account указывающий на реальный банковский счёт.
   */
  BillingCoreAccountTypeEnum["BANK"] = "BANK";
  /**
   * 55: Счёт размещения средств до момента вывода на счета типа BANK.
   * Обычно это счёт в мерчант-сервисе для приёма и распределения платежей.
   * Счета данного типа всегда должны иметь external
   * account указывающий на счёт в мерчант-сервисе.
   */
  BillingCoreAccountTypeEnum["TRANSIT"] = "TRANSIT";
  // #endregion
  // #region [ Бухгалтерские счета ]
  /**
   * 64 (62.02) Расчеты по авансам полученным. На данный тип счетов
   * зачисляются денежные средства полученные в качестве аванса.
   */
  BillingCoreAccountTypeEnum["ADVANCES_RECEIVED"] = "ADVANCES_RECEIVED";
  /**
   * 68: Расчеты по налогам и сборам (Обязательства перед налоговой).
   * На данный счёт зачисляются средства, которые должны быть выплачены
   * в налоговый орган. Можно открыть субсчета для различных стран и регионов.
   */
  BillingCoreAccountTypeEnum["TAX_SETTLEMENTS"] = "TAX_SETTLEMENTS";
  /**
   * 60: Расчёт с поставщиками и подрядчиками (Обязательства перед продавцами).
   */
  BillingCoreAccountTypeEnum["CONTRACTORS_SETTLEMENTS"] = "CONTRACTORS_SETTLEMENTS";
  /**
   * 90: Доход.
   */
  BillingCoreAccountTypeEnum["INCOME"] = "INCOME";
  /**
   * 91: Прочие доходы и расходы.
   */
  BillingCoreAccountTypeEnum["OTHER"] = "OTHER";
  /**
   * 91.02: Прочие расходы (для различных банковских и мерчант комиссий).
   */
  BillingCoreAccountTypeEnum["OTHER_EXPENSES"] = "OTHER_EXPENSES";
  // #region
  // #region [ Прочие счета ]
  /**
   * Лицевые счета на сайте в реальной или внутрисайтовой
   * валюте. Средства покупаются за реальные деньги, начисляются
   * за заслуги, пополняются с помощью сертификата, начисляются в виде бонусов
   * и т.д. Движения по счетам даного типа не приводят в внутрибанковским переводам
   * реальных средств, однако могут быть куплены или проданы за реальные
   * деньги.
   */
  BillingCoreAccountTypeEnum["PERSONAL"] = "PERSONAL";
  // #region
})(BillingCoreAccountTypeEnum = exports.BillingCoreAccountTypeEnum || (exports.BillingCoreAccountTypeEnum = {}));
